if (!customElements.get('kit-tabs')) {
  customElements.define(
    'kit-tabs',
    class KitTabs extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.container = this.querySelector('[data-kit-tabs-panels]');
        this.more = this.querySelector('[data-kit-tabs-more]');
        if (!this.list || !this.container || this.tabs.length === 0) return;

        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.running = [];
        this.list.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        });
        this.list.addEventListener('keydown', (event) => this.onKey(event));
        ['pointerover', 'focusin', 'touchstart'].forEach((type) =>
          this.list.addEventListener(type, (event) => this.warm(event.target.closest('[role="tab"]')), { passive: true })
        );
      }

      panelFor(tab) {
        return document.getElementById(tab.getAttribute('aria-controls'));
      }

      current() {
        return this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      }

      onKey(event) {
        const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
        if (index < 0) return;
        const last = this.tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.tabs[next].focus({ preventScroll: true });
        this.select(this.tabs[next]);
      }

      select(tab) {
        const previous = this.current();
        if (tab === previous) return;

        const startHeight = this.container.getBoundingClientRect().height;
        this.settle();
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.list.style.setProperty('--kit-tab-index', this.tabs.indexOf(tab));
        if (this.more) {
          this.more.href = tab.dataset.moreHref;
          this.more.querySelector('[data-kit-tabs-more-label]').textContent = tab.dataset.moreLabel;
        }
        this.swap(this.panelFor(previous), this.panelFor(tab), startHeight);
      }

      swap(outgoing, incoming, startHeight) {
        this.warm(incoming);
        incoming.hidden = false;
        if (this.motion.matches) {
          outgoing.hidden = true;
          return;
        }

        outgoing.inert = true;
        const endHeight = incoming.getBoundingClientRect().height;
        const ease = 'cubic-bezier(0, 0, 0.3, 1)';
        this.container.style.overflow = 'hidden';
        this.running = [
          this.container.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, { duration: 250, easing: ease }),
          outgoing.animate({ opacity: [1, 0] }, { duration: 100, easing: 'linear', fill: 'forwards' }),
          incoming.animate({ opacity: [0, 1], transform: ['translateY(0.6rem)', 'none'] }, { duration: 200, delay: 50, easing: ease, fill: 'backwards' }),
        ];
        this.running[0].finished.then(() => this.settle()).catch(() => {});
      }

      settle() {
        this.running.forEach((animation) => animation.cancel());
        this.running = [];
        this.container.style.removeProperty('overflow');
        const active = this.panelFor(this.current());
        this.tabs.forEach((tab) => {
          const panel = this.panelFor(tab);
          panel.hidden = panel !== active;
          panel.inert = false;
        });
      }

      warm(target) {
        const panel = target && target.getAttribute('role') === 'tab' ? this.panelFor(target) : target;
        if (!panel) return;
        panel.querySelectorAll('img[loading="lazy"]').forEach((image) => {
          image.loading = 'eager';
        });
      }
    }
  );
}
